import { initiativeCreationSteps } from '../blocks/workflow'
import { CreationGuide } from '../blocks/CreationGuide'
import Column from '@app/components/layout/Column'
import { useClient } from '@based/sdk'
import { useEffect } from 'react'

export const FinishStep = ({ initiativeId }: { initiativeId: number }) => {
  const client = useClient()

  useEffect(() => {
    client
      .call('calculate-slug-initiative', { id: initiativeId })
      .catch(() => {
        // Intentionally ignore errors; previous behavior did not handle them
      })
  }, [client, initiativeId])

  return (
    <CreationGuide
      selectedPhaseType={null}
      currentStep={initiativeCreationSteps.finish}
    >
      <Column gap="2.5rem" alignItems="stetch">
        <div></div>
      </Column>
    </CreationGuide>
  )
}
